import { render, staticRenderFns } from "./GranularitySwitcher.vue?vue&type=template&id=4829dc18&"
import script from "./GranularitySwitcher.vue?vue&type=script&lang=ts&"
export * from "./GranularitySwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports